import { render } from "./yzgAccount.vue?vue&type=template&id=4c427671&scoped=true"
import script from "./yzgAccount.vue?vue&type=script&lang=js"
export * from "./yzgAccount.vue?vue&type=script&lang=js"

import "./yzgAccount.vue?vue&type=style&index=0&id=4c427671&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c427671"]])

export default __exports__